import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { MoonStar, Sun } from 'lucide-react';
import { getPreferredThemeMode, onThemeModeChange, toggleThemeMode } from '../utils/themeMode';

const isStaffPath = (pathname = '') => {
  const path = String(pathname || '');
  if (path === '/dadu/login' || path === '/portal/login') return false;
  return (
    path.startsWith('/dadu')
    || path.startsWith('/portal')
    || path.startsWith('/teknisi')
    || path.startsWith('/investor')
    || path.startsWith('/noc')
    || path.startsWith('/performa-teknisi')
  );
};

export default function ThemeModeToggleFloating() {
  const location = useLocation();
  const [mode, setMode] = useState(() => getPreferredThemeMode());

  useEffect(() => onThemeModeChange(setMode), []);

  const visible = useMemo(() => {
    const path = location.pathname || '';
    if (!isStaffPath(path)) return false;
    if (path.startsWith('/dadu')) return false;
    return true;
  }, [location.pathname]);

  if (!visible) return null;

  const isLight = mode === 'light';

  return (
    <button
      type="button"
      onClick={() => setMode(toggleThemeMode())}
      className="fixed right-4 bottom-4 z-[1200] inline-flex items-center gap-2 rounded-full border border-cyan-300/45 bg-[#0f1b30]/90 px-3 py-2 text-xs font-semibold text-cyan-100 shadow-lg backdrop-blur transition hover:scale-[1.02] hover:bg-cyan-500/20"
      aria-label="Ganti mode tema"
      title={isLight ? 'Aktif: Mode Terang (klik untuk gelap)' : 'Aktif: Mode Gelap (klik untuk terang)'}
    >
      {isLight ? <Sun className="h-4 w-4 text-amber-300" /> : <MoonStar className="h-4 w-4 text-cyan-200" />}
      <span>{isLight ? 'Mode Terang' : 'Mode Gelap'}</span>
    </button>
  );
}
